import React from 'react';
import { Link } from 'react-router-dom';
import { PageCenterLayout } from '../components/UI/PageCenterLayout';
import { AmbientBlobs, type BlobConfig } from '../components/UI/AmbientBlobs';
import { ErrorPageLayout } from '../components/UI/ErrorPageLayout';
import { Button } from '../components/UI/Button';

const BLOBS: BlobConfig[] = [
  {
    gradient: 'radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 70%)',
    position: { top: '25%', left: '25%' },
    size: 400,
    duration: 6,
  },
  {
    gradient: 'radial-gradient(circle, rgba(167,139,250,0.10) 0%, transparent 70%)',
    position: { bottom: '25%', right: '25%' },
    size: 350,
    duration: 7,
    delay: 1.5,
  },
];

export const NotFoundPage: React.FC = () => (
  <PageCenterLayout>
    <AmbientBlobs blobs={BLOBS} />
    <ErrorPageLayout
      characterState="Not Found"
      heading="404"
      title="Page not found"
      description="The page you're looking for doesn't exist or has been moved."
      cta={<Link to="/albums"><Button>Go to Albums</Button></Link>}
    />
  </PageCenterLayout>
);
